import styles from './Footer.module.css'

const Footer = () => {
  return (
    <div className={styles.container_footer}>
        <div>
            <span>Desenvolvido por CFA Full-ecommerce</span>
            <span>R. Baicker Bernardino - Jardim Canaã, Uberlândia - MG</span>
        </div>
    </div>
  )
}

export default Footer